import { useState } from "react";
import { OptionType } from "@shared/ui/Select";
import useGetOrganizations from "@shared/hooks/useGetOrganizations";

export function useOrgExperience() {
  const [selectedOrg, setSelectedOrg] = useState<OptionType | null>(null);

  const { options: loadedOptions, isLoading } = useGetOrganizations({
    shouldLoad: true,
  });

  const [extraOptions, setExtraOptions] = useState<OptionType[]>([]);

  // Combine loaded and created options
  const combinedOptions = [...loadedOptions, ...extraOptions].filter(
    (option, index, self) =>
      index === self.findIndex((o) => o.value === option.value)
  );

  const handleCreateOrganization = (inputValue: string) => {
    const newOption: OptionType = {
      label: inputValue,
      value: inputValue.toLowerCase().replace(/\s+/g, "-"),
      data: { created: true },
    };

    setExtraOptions((prev) => {
      const exists = prev.some((opt) => opt.value === newOption.value);
      return exists ? prev : [...prev, newOption];
    });

    setSelectedOrg(newOption);
  };

  const handleSelectOrganization = (option: OptionType) => {
    setSelectedOrg(option);
  };

  return {
    handleCreateOrganization,
    handleSelectOrganization,
    options: combinedOptions,
    isLoading,
    selectedOrg,
  };
}

export default useOrgExperience;
